import { Component, ViewChild, ElementRef, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Output, signal, inject, HostListener, effect, OnInit } from '@angular/core';
import { MagicSearchService } from '../../../creators/service/magic-search/magic-search.service';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActiveFiltersModel, FilterCreatorsDto, FilterErrorLogsDto, FilterItemDto, FiltersModel } from '../../../../common/general-types/filters.dto';
import { MatSliderModule } from '@angular/material/slider';
import { Subscription } from 'rxjs';
import {
  FOLLOWER_RANGE_DEFAULT,
  FOLLOWER_RANGE_MAX_INDEX,
  FOLLOWER_RANGE_STEP_LABELS,
  FollowerRangeValue,
  followerStepIndexToValue,
  followerValueToStepIndex,
  formatFollowerRangeLabel,
  formatFollowerStepLabel,
  isDefaultFollowerRange,
} from '../../../../common/app-config/filter-models/follower-range';

type FollowerPlatformKey = 'tiktok' | 'instagram' | 'youtube' | 'snapchat';

@Component({
  selector: 'cfv4-filter-drawer',
  standalone: true,
  imports: [MatSliderModule, FormsModule, ReactiveFormsModule],
  templateUrl: './filter-drawer.component.html',
  styleUrl: './filter-drawer.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class FilterDrawerComponent implements OnInit {


  @ViewChild('filterDrawerDialog', { static: false }) filterDrawerDialog?: ElementRef<HTMLDialogElement>;
  @ViewChild('filterDrawerButton', { static: false }) filterDrawerButton?: ElementRef<HTMLButtonElement>;
  private dialogCloseHandler?: () => void;

  @ViewChild('searchTermInput', { static: false }) searchTermInput!: ElementRef<HTMLInputElement>;

  @Output() close = new EventEmitter<void>();


  selectedTab = signal<'location' | 'profile' | 'followers' | 'interests' | 'sort'>('profile');

  filtersForm!: FormGroup;
  filtersObject!: FilterCreatorsDto | FilterErrorLogsDto;

  ageRangeDefault = {
    disabled: false,
    max: 65,
    min: 16,
    showTicks: false,
    step: 1,
    thumbLabel: false,
    minValue: 16,
    maxValue: 65,
  }

  readonly followerStepMaxIndex = FOLLOWER_RANGE_MAX_INDEX;
  readonly followerStepLabels = FOLLOWER_RANGE_STEP_LABELS;
  followerRangeSliderDefaults = {
    disabled: false,
    max: FOLLOWER_RANGE_MAX_INDEX,
    min: 0,
    step: 1,
    showTicks: true,
    thumbLabel: false,
  };
  tiktokFollowerSlider = { minValue: 0, maxValue: FOLLOWER_RANGE_MAX_INDEX };
  instagramFollowerSlider = { minValue: 0, maxValue: FOLLOWER_RANGE_MAX_INDEX };
  youtubeFollowerSlider = { minValue: 0, maxValue: FOLLOWER_RANGE_MAX_INDEX };
  snapchatFollowerSlider = { minValue: 0, maxValue: FOLLOWER_RANGE_MAX_INDEX };

  selectedFilters: { filter: string, value: any }[] = [];


  tiktokCollapsed = signal(false);
  instagramCollapsed = signal(false);
  youtubeCollapsed = signal(false);
  snapchatCollapsed = signal(false);
  isDefaultSearch = signal(false);
  isPagination = signal(false);

  subFilters$!: Subscription;
  subscriptionList = new Subscription();


  @HostListener('document:keydown.enter', ['$event' as any])
  handleEnterKey(event: KeyboardEvent) {
    this.filterSearch();
  }

  @HostListener('document:keydown.escape', ['$event' as any])
  handleEscapeKey(event: KeyboardEvent) {
    this.closeDrawer();
  }

  /** Services */
  public magicSearchService = inject(MagicSearchService);
  /** Services - END */

  constructor() {
    effect(() => {
      console.log('🧨🧨🧨 effect() 111 🧨🧨🧨');
      const filters = this.magicSearchService.filtersObjectSignal();

      console.log('filters', filters);
      const activeFilters =
        this.magicSearchService.fancyActiveFilters ?? this.magicSearchService.activeFiltersSignal();
      console.log('fancyActiveFilters (for setFormValues)', activeFilters);

      if (filters) {
        const searchTerm = filters.searchTerm && filters.searchTerm !== '' ? filters.searchTerm : null;
        this.setFormValues(filters, activeFilters);

        this.magicSearchService.fancyActiveFilters = this.magicSearchService.activeFiltersSignal();
      }
    }, { allowSignalWrites: true });

    // Watch for tab and modal changes to focus input
    effect(() => {
      console.log('🧨🧨🧨 effect() 222 🧨🧨🧨');
      const tab = this.selectedTab();
      const isOpen = this.magicSearchService.filtersOpen();

      if (tab === 'profile' && isOpen) {
        setTimeout(() => {
          this.focusSearchInput();
        }, 150);
      }
    });

    this.filtersObject = {};
    this.filtersForm = new FormGroup({
      homeTownSearchTerm: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      searchTerm: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      country: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      gender: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      ageRange: new FormControl(
        {
          value: { min: 16, max: 65 },
          disabled: false
        }, []),
      platform: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      tiktokFollowersRange: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      instagramFollowersRange: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      youtubeSubscribersRange: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      snapchatFollowersRange: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      interests: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
      sortSelected: new FormControl(
        {
          value: null,
          disabled: false
        }, []),
    })
  }

  get formControl() {
    return this.filtersForm.controls;
  }

  ngOnInit(): void {
    this.isDefaultSearch.set(true);
    this.listenToFormChanges();
  }

  listenToFormChanges(): void {
    this.subFilters$ = this.filtersForm.valueChanges.subscribe({
      next: (formValues) => {
        this.updateTotalFilters(formValues);

        if (formValues.searchTerm !== undefined) {
          this.magicSearchService.searchQuery.set(formValues.searchTerm || '');
        }


        this.selectedFilters = [];
        // console.log('filtersForm: ', this.filtersForm);
        // console.log('filtersForm - value: ', this.filtersForm.value);

        if (this.filtersForm && this.filtersForm.value) {
          Object.keys(this.filtersForm.value).forEach((key: any) => {
            if (this.filtersForm.value[key]) {
              if (key == 'ageRange') {
                this.selectedFilters.push({ filter: key, value: `${this.filtersForm.value[key].min} - ${this.filtersForm.value[key].max}` });
              } else if (key == 'gender') {
                this.selectedFilters.push({ filter: key, value: this.filtersForm.value[key].name });
              } else if (key == 'country') {
                this.selectedFilters.push({ filter: key, value: this.filtersForm.value[key].name });
              } else if (key == 'tiktokFollowersRange') {
                this.selectedFilters.push({
                  filter: 'TikTok',
                  value: `TikTok - ${formatFollowerRangeLabel(this.filtersForm.value[key])}`,
                });
              } else if (key == 'instagramFollowersRange') {
                this.selectedFilters.push({
                  filter: 'Instagram',
                  value: `Instagram - ${formatFollowerRangeLabel(this.filtersForm.value[key])}`,
                });
              } else if (key == 'snapchatFollowersRange') {
                this.selectedFilters.push({
                  filter: 'Snapchat',
                  value: `Snapchat - ${formatFollowerRangeLabel(this.filtersForm.value[key])}`,
                });
              } else if (key == 'youtubeSubscribersRange') {
                this.selectedFilters.push({
                  filter: 'YouTube',
                  value: `YouTube - ${formatFollowerRangeLabel(this.filtersForm.value[key])}`,
                });
              } else if (key == 'interests') {
                const uniqueInterests = this.filtersForm.value[key].filter((interest: any, index: number, self: any[]) =>
                  index === self.findIndex((i: any) => i.name === interest.name)
                );
                this.selectedFilters.push({ filter: 'Interests', value: `Interests - ${uniqueInterests.map((interest: any) => interest.name).join(', ')}` });
              } else if (key == 'sortSelected') {
                this.selectedFilters.push({ filter: 'Sort', value: this.filtersForm.value[key].name });
              }
              else {
                this.selectedFilters.push({ filter: key, value: this.filtersForm.value[key] });
              }
            }
          });

          // Remove duplicates based on filter and value combination
          this.selectedFilters = this.selectedFilters.filter((item, index, self) =>
            index === self.findIndex((t) => t.filter === item.filter && t.value === item.value)
          );

          // this.selectedFilters = this.selectedFilters.sort((a, b) => a.filter.localeCompare(b.filter));
        }

      },
      error: error => {
        console.error('filters-drawer error: ', error);
      }
    });
    this.subscriptionList.add(this.subFilters$);
  }

  updateTotalFilters(formValues: any): void {
    this.magicSearchService.fancyTotalFilters.set(Object.keys(formValues).reduce((count, key) => {
      if (formValues[key] !== null && formValues[key] !== '') {
        return count + 1;
      }
      return count;
    }, 0));
  }


  setFormValues(filtersSignal: FilterCreatorsDto | FilterErrorLogsDto, activeFilters: ActiveFiltersModel | undefined) {
    console.log('>> setFormValues() - filtersSignal', filtersSignal);
    console.log('>> setFormValues() - activeFilters', activeFilters);

    if (filtersSignal.country) {
      if (activeFilters && activeFilters.countryOptions) {
        activeFilters.countryOptions?.forEach(country => {
          if (filtersSignal && filtersSignal.country && filtersSignal.country.length === 1 && (filtersSignal.country[0] === country.id)) {
            this.onSelectedSingleOptionsChange(country, 'country');
          }
        });
      }
    } else {
      this.formControl['country'].setValue(null);
    }

    if (filtersSignal.homeTownSearchTerm) {
      this.formControl['homeTownSearchTerm'].setValue(filtersSignal.homeTownSearchTerm);
    } else {
      this.formControl['homeTownSearchTerm'].setValue(null);
    }

    if (filtersSignal.searchTerm) {
      this.formControl['searchTerm'].setValue(filtersSignal.searchTerm);
    } else {
      this.formControl['searchTerm'].setValue(null);
    }

    if (filtersSignal.gender) {
      if (activeFilters && activeFilters.genderOptions) {
        activeFilters.genderOptions?.forEach(gender => {
          if (filtersSignal && filtersSignal.gender && filtersSignal.gender.length === 1 && (filtersSignal.gender[0] === gender.id)) {
            this.onSelectedSingleOptionsChange(gender, 'gender');
          }
        });
      }
    } else {
      this.formControl['gender'].setValue(null);
    }

    if (filtersSignal.ageFrom) {
      this.formControl['ageRange'].setValue({ min: filtersSignal.ageFrom, max: filtersSignal.ageTo });
      this.ageRangeDefault.minValue = filtersSignal.ageFrom;
    } else {
      this.formControl['ageRange'].setValue({ min: this.ageRangeDefault.min, max: this.ageRangeDefault.max });
    }
    if (filtersSignal.ageTo) {
      this.formControl['ageRange'].setValue({ min: this.formControl['ageRange'].value.min, max: filtersSignal.ageTo });
      this.ageRangeDefault.maxValue = filtersSignal.ageTo;
    }

    // TikTok Followers
    this.hydrateFollowerRange(
      'tiktok',
      filtersSignal['tiktokFollowersRange'] as FollowerRangeValue | null | undefined,
      filtersSignal.tikTokFollowersFrom,
      filtersSignal.tikTokFollowersTo,
    );

    // Instagram Followers
    this.hydrateFollowerRange(
      'instagram',
      filtersSignal['instagramFollowersRange'] as FollowerRangeValue | null | undefined,
      filtersSignal.instagramFollowersFrom,
      filtersSignal.instagramFollowersTo,
    );

    // Snapchat Followers
    this.hydrateFollowerRange(
      'snapchat',
      filtersSignal['snapchatFollowersRange'] as FollowerRangeValue | null | undefined,
      filtersSignal.snapchatFollowersFrom,
      filtersSignal.snapchatFollowersTo,
    );

    // YouTube Subscribers
    this.hydrateFollowerRange(
      'youtube',
      filtersSignal['youtubeSubscribersRange'] as FollowerRangeValue | null | undefined,
      filtersSignal.youtubeSubscribersFrom,
      filtersSignal.youtubeSubscribersTo,
    );

    if (filtersSignal.interests && filtersSignal.interests.length) {
      if (activeFilters?.interestsOptions) {
        const selectedInterests = activeFilters.interestsOptions.filter(interest =>
          filtersSignal.interests?.includes(interest.id as number)
        );
        this.onSelectedMultipleOptionsChange(selectedInterests, 'interests');
      }
    } else {
      this.formControl['interests'].setValue(null);
    }

    // Sort
    if (filtersSignal['sort']) {
      this.onSelectedSingleOptionsChange(filtersSignal['sort'], 'sortSelected');
    } else {
      this.formControl['sortSelected'].setValue(null);
    }
  }

  selectSizeOption(sizeOption: FilterItemDto, formControl: string): void {
    console.log('>> selectSizeOption() - sizeOption', sizeOption);
  }

  private followerRangeFormKey(platform: FollowerPlatformKey): string {
    switch (platform) {
      case 'tiktok':
        return 'tiktokFollowersRange';
      case 'instagram':
        return 'instagramFollowersRange';
      case 'youtube':
        return 'youtubeSubscribersRange';
      case 'snapchat':
        return 'snapchatFollowersRange';
    }
  }

  private getFollowerSlider(platform: FollowerPlatformKey): { minValue: number; maxValue: number } {
    switch (platform) {
      case 'tiktok':
        return this.tiktokFollowerSlider;
      case 'instagram':
        return this.instagramFollowerSlider;
      case 'youtube':
        return this.youtubeFollowerSlider;
      case 'snapchat':
        return this.snapchatFollowerSlider;
    }
  }

  formatFollowerStep(index: number): string {
    return formatFollowerStepLabel(followerStepIndexToValue(index));
  }

  formatFollowerRange(range: FollowerRangeValue): string {
    return formatFollowerRangeLabel(range);
  }

  onFollowerRangeChange(platform: FollowerPlatformKey, event: number, type: 'min' | 'max'): void {
    const slider = this.getFollowerSlider(platform);
    if (type === 'min') {
      slider.minValue = event;
      if (slider.minValue > slider.maxValue) {
        slider.maxValue = slider.minValue;
      }
    } else {
      slider.maxValue = event;
      if (slider.maxValue < slider.minValue) {
        slider.minValue = slider.maxValue;
      }
    }

    const range: FollowerRangeValue = {
      min: followerStepIndexToValue(slider.minValue),
      max: followerStepIndexToValue(slider.maxValue),
    };
    this.formControl[this.followerRangeFormKey(platform)].setValue(
      isDefaultFollowerRange(range) ? null : range,
    );
  }

  private resetFollowerRange(platform: FollowerPlatformKey): void {
    const slider = this.getFollowerSlider(platform);
    slider.minValue = 0;
    slider.maxValue = FOLLOWER_RANGE_MAX_INDEX;
    this.formControl[this.followerRangeFormKey(platform)].setValue(null);
  }

  private applyFollowerRange(platform: FollowerPlatformKey, range: FollowerRangeValue): void {
    const slider = this.getFollowerSlider(platform);
    slider.minValue = followerValueToStepIndex(range.min);
    slider.maxValue = followerValueToStepIndex(range.max);
    if (slider.minValue > slider.maxValue) {
      const swap = slider.minValue;
      slider.minValue = slider.maxValue;
      slider.maxValue = swap;
    }
    const snapped: FollowerRangeValue = {
      min: followerStepIndexToValue(slider.minValue),
      max: followerStepIndexToValue(slider.maxValue),
    };
    this.formControl[this.followerRangeFormKey(platform)].setValue(
      isDefaultFollowerRange(snapped) ? null : snapped,
    );
  }

  private hydrateFollowerRange(
    platform: FollowerPlatformKey,
    uiRange: FollowerRangeValue | null | undefined,
    from?: number | null,
    to?: number | null,
  ): void {
    if (uiRange && !isDefaultFollowerRange(uiRange)) {
      this.applyFollowerRange(platform, uiRange);
      return;
    }
    if (from != null || to != null) {
      this.applyFollowerRange(platform, {
        min: from ?? FOLLOWER_RANGE_DEFAULT.min,
        max: to ?? FOLLOWER_RANGE_DEFAULT.max,
      });
      return;
    }
    this.resetFollowerRange(platform);
  }

  /** Chip remove: reset one platform range and re-run search. */
  clearFollowerRangeAndRepublish(platform: FollowerPlatformKey): void {
    this.resetFollowerRange(platform);
    this.publishFormToMagicSearch();
  }

  onSelectedSingleOptionsChange(selectedOption: FilterItemDto, formControl: string): void {
    console.log('>> onSelectedSingleOptionsChange() - selectedOption', selectedOption);
    console.log('>> onSelectedSingleOptionsChange() - formControl', formControl);
    this.formControl[formControl].setValue(selectedOption);
    if (!selectedOption) {
      this.formControl[formControl].setValue(null);
    }
    console.log('>> onSelectedSingleOptionsChange() - formControl', this.formControl[formControl].value);
  }

  onSelectedMultipleOptionsChange(selectedOptions: FilterItemDto[], formControl: string): void {
    this.magicSearchService.fancyInterestsSelected = selectedOptions.length;
    this.formControl[formControl].setValue(selectedOptions);
    if (!selectedOptions.length) {
      this.formControl[formControl].setValue(null);
    }
  }

  uiOneOfMultipleSelectionChange(selectedOption: FilterItemDto, formControl: string): void {
    console.log('>> uiOneOfMultipleSelectionChange() - selectedOption', selectedOption);
    console.log('>> uiOneOfMultipleSelectionChange() - formControl', formControl);
    this.magicSearchService.fancyInterestsSelected += 1 || 1;
    if (this.formControl[formControl].value && this.formControl[formControl].value.length && this.formControl[formControl].value.length >= 1) {
      const currentInterests = this.formControl[formControl].value;
      const updatedInterests = [...currentInterests, selectedOption];
      this.formControl[formControl].setValue(updatedInterests);
    } else {
      this.formControl[formControl].setValue([selectedOption]);
    }
    // console.log('>> uiOneOfMultipleSelectionChange() - formControl', this.formControl[formControl].value);
  }

  setFiltersTab(tab: 'location' | 'profile' | 'followers' | 'interests' | 'sort') {
    this.selectedTab.set(tab);
    // Focus input when profile tab is selected
    if (tab === 'profile') {
      setTimeout(() => {
        this.focusSearchInput();
      }, 100);
    }
  }

  private focusSearchInput(): void {
    // Focus when profile tab is selected and modal is open
    if (this.selectedTab() === 'profile' &&
      this.magicSearchService.filtersOpen() &&
      this.searchTermInput?.nativeElement) {
      // Use setTimeout to ensure DOM is ready
      setTimeout(() => {
        this.searchTermInput.nativeElement?.focus();
      }, 0);
    }
  }

  onAgeRangeChange(event: Event, type: 'min' | 'max') {
    if (type === 'min') {
      this.formControl['ageRange'].setValue({ min: event, max: this.formControl['ageRange'].value.max });
    } else {
      this.formControl['ageRange'].setValue({ min: this.formControl['ageRange'].value.min, max: event });
    }
  }


  getTabClass(tab: 'location' | 'profile' | 'followers' | 'interests' | 'sort') {
    if (this.selectedTab() === tab) {
      return 'border-[--primary] text-[--primary]';
    }
    return 'border-transparent text-secondary hover:border-[--border] hover:text-primary';
  }

  getSelectedTabIconClass(tab: 'location' | 'profile' | 'followers' | 'interests' | 'sort') {
    if (this.selectedTab() == tab) {
      return 'text-[--primary]';
    }
    return 'text-secondary group-hover:text-primary';
  }



  resetFilters() {
    console.log('>> resetFilters()');
  }

  filterSearch() {
    console.log('>> filterSearch()');
    this.publishFormToMagicSearch();
    this.closeDrawer();
  }

  /** Sync drawer form → applied filters + search (used by Apply and toolbar sort). */
  private publishFormToMagicSearch(): void {
    const constructedFilters = {
      ageOptions: this.formControl['ageRange'].value,
      interests: this.formControl['interests'].value,
      country: this.formControl['country'].value,
      gender: this.formControl['gender'].value,
      platform: this.formControl['platform'].value,
      tiktokFollowersRange: this.formControl['tiktokFollowersRange'].value,
      instagramFollowersRange: this.formControl['instagramFollowersRange'].value,
      youtubeSubscribersRange: this.formControl['youtubeSubscribersRange'].value,
      snapchatFollowersRange: this.formControl['snapchatFollowersRange'].value,
      sort: this.formControl['sortSelected'].value,
      homeTownSearchTerm: this.formControl['homeTownSearchTerm'].value,
      searchTerm: this.formControl['searchTerm'].value,
    };

    console.log('constructedFilters', constructedFilters);

    this.magicSearchService.appliedFilters = this.setFilterValues(constructedFilters);

    this.magicSearchService.filtersObjectSignal.set(constructedFilters);

    this.magicSearchService.kickOffBlueSearch(this.magicSearchService.appliedFilters, this.isPagination(), this.isDefaultSearch());
    this.isDefaultSearch.set(false);
  }

  /** Toolbar sort: same form control + same publish pipeline as Apply. */
  applySortFromToolbar(sortOption: FilterItemDto): void {
    this.onSelectedSingleOptionsChange(sortOption, 'sortSelected');
    this.publishFormToMagicSearch();
  }

  /** Reset sort on the shared form and re-run search (e.g. chip remove). */
  clearSortAndRepublish(): void {
    this.formControl['sortSelected'].setValue(null);
    this.publishFormToMagicSearch();
  }

  setFilterValues(filters: FiltersModel) {
    let constructedFilters: FilterCreatorsDto = {};

    if (filters.homeTownSearchTerm) {
      constructedFilters.homeTownSearchTerm = filters.homeTownSearchTerm.toLowerCase();
    }

    if (filters.searchTerm) {
      constructedFilters.searchTerm = filters.searchTerm.toLowerCase();
    }

    if (filters.country) {
      constructedFilters.country = [filters.country.id as string];
    } else {
      if (constructedFilters.country) {
        delete constructedFilters.country;
      }
    }
    if (filters.gender) {
      constructedFilters.gender = [filters.gender.id as number];
    } else {
      if (constructedFilters.gender) {
        delete constructedFilters.gender;
      }
    }

    if (filters.ageOptions) {
      constructedFilters.ageFrom = filters.ageOptions.min;
      constructedFilters.ageTo = filters.ageOptions.max;
    } else {
      if (constructedFilters.ageFrom) {
        delete constructedFilters.ageFrom;
      }
      if (constructedFilters.ageTo) {
        delete constructedFilters.ageTo;
      }
    }

    console.log('****** filters.tiktokFollowersRange', filters.tiktokFollowersRange);

    if (filters.tiktokFollowersRange && !isDefaultFollowerRange(filters.tiktokFollowersRange)) {
      constructedFilters.tikTokFollowersFrom = filters.tiktokFollowersRange.min;
      constructedFilters.tikTokFollowersTo = filters.tiktokFollowersRange.max;
    } else {
      if (constructedFilters.tikTokFollowersFrom) {
        delete constructedFilters.tikTokFollowersFrom;
      }
      if (constructedFilters.tikTokFollowersTo) {
        delete constructedFilters.tikTokFollowersTo;
      }
    }

    if (filters.instagramFollowersRange && !isDefaultFollowerRange(filters.instagramFollowersRange)) {
      constructedFilters.instagramFollowersFrom = filters.instagramFollowersRange.min;
      constructedFilters.instagramFollowersTo = filters.instagramFollowersRange.max;
    } else {
      if (constructedFilters.instagramFollowersFrom) {
        delete constructedFilters.instagramFollowersFrom;
      }
      if (constructedFilters.instagramFollowersTo) {
        delete constructedFilters.instagramFollowersTo;
      }
    }

    if (filters.snapchatFollowersRange && !isDefaultFollowerRange(filters.snapchatFollowersRange)) {
      constructedFilters.snapchatFollowersFrom = filters.snapchatFollowersRange.min;
      constructedFilters.snapchatFollowersTo = filters.snapchatFollowersRange.max;
    } else {
      if (constructedFilters.snapchatFollowersFrom) {
        delete constructedFilters.snapchatFollowersFrom;
      }
      if (constructedFilters.snapchatFollowersTo) {
        delete constructedFilters.snapchatFollowersTo;
      }
    }

    if (filters.youtubeSubscribersRange && !isDefaultFollowerRange(filters.youtubeSubscribersRange)) {
      constructedFilters.youtubeSubscribersFrom = filters.youtubeSubscribersRange.min;
      constructedFilters.youtubeSubscribersTo = filters.youtubeSubscribersRange.max;
    } else {
      if (constructedFilters.youtubeSubscribersFrom) {
        delete constructedFilters.youtubeSubscribersFrom;
      }
      if (constructedFilters.youtubeSubscribersTo) {
        delete constructedFilters.youtubeSubscribersTo;
      }
    }

    if (filters.interests) {
      constructedFilters.interests = filters.interests.map((interest: any) => interest.id as number);
    } else {
      if (constructedFilters.interests) {
        delete constructedFilters.interests;
      }
    }

    if (filters.sort) {
      constructedFilters.sortField = filters.sort.value as string;
      constructedFilters.sortOrder = filters.sort.direction as string;
    }
    else {
      constructedFilters.sortField = 'creator.average_rating';
      constructedFilters.sortOrder = 'DESC';
    }

    return constructedFilters;
  }

  clearFilters() {
    this.filtersForm.reset();
    this.magicSearchService.appliedFilters = {};
    this.magicSearchService.filtersObjectSignal.set({});
    this.ageRangeDefault.minValue = 16;
    this.ageRangeDefault.maxValue = 65;
    this.formControl['ageRange'].setValue({ min: 16, max: 65 });
    this.formControl['interests'].setValue(null);
    this.formControl['country'].setValue(null);
    this.formControl['gender'].setValue(null);
    this.formControl['platform'].setValue(null);
    this.resetFollowerRange('tiktok');
    this.resetFollowerRange('instagram');
    this.resetFollowerRange('youtube');
    this.resetFollowerRange('snapchat');
    this.formControl['sortSelected'].setValue(null);
    this.formControl['homeTownSearchTerm'].setValue(null);
    this.magicSearchService.kickOffBlueSearch(this.magicSearchService.appliedFilters, this.isPagination(), this.isDefaultSearch());
    this.isDefaultSearch.set(false);
    this.closeDrawer();
  }

  closeDrawer() {
    this.filterDrawerDialog?.nativeElement?.close();
    this.close.emit();
    if (this.dialogCloseHandler) {
      this.dialogCloseHandler();
    }
  }
}
